import React from 'react';
import {Scrollbar} from '@priority-software/priority-style-react';
import {ListIem} from './ListIem';
import {SettingsPanelCol} from '../../Common/consts';
import {isRTL} from '../../../../../../Localization';

type ContentProps = {
    cols: SettingsPanelCol[];
    handleChange: () => void;
};

export const Content = ({cols, handleChange}: ContentProps) => {
    const compare = (a: SettingsPanelCol, b: SettingsPanelCol) => {
        return Number(b.isDefault) - Number(a.isDefault);
    };
    return (
        <Scrollbar autoHeight autoHeightMin={60} rtl={isRTL()}>
            {cols
                ?.slice()
                ?.sort(compare)
                .map(col => {
                    return <ListIem col={col} handleChange={handleChange} key={col.name} />;
                })}
        </Scrollbar>
    );
};
